// Customizable Area Start
import React, { Component } from "react";
import { Dialog, DialogProps, styled } from "@mui/material";

const CustomDialog = styled(Dialog)(({ fullScreen }) => ({
  "& .MuiPaper-root": {
    borderRadius: fullScreen ? "0px" : "20px",
    backgroundColor: "#fff",
    padding: "30px 70px 20px",
    position: "relative",
    maxWidth: fullScreen ? "auto" : "600px",
    minWidth: "430px",
    minHeight: "294px",
    "@media (max-width: 850px)": {
      padding: "25px 40px",
    },
    "@media (max-width: 450px)": {
      minWidth: "auto",
      padding: "20px 25px",
      minHeight: "250px",
    },
  },
}));

interface Props extends DialogProps {
  children: React.ReactNode;
}

class CustomDialogWrapper extends Component<Props> {
  render() {
    const { children, ...rest } = this.props;
    return <CustomDialog {...rest}>{children}</CustomDialog>;
  }
}

export default CustomDialogWrapper;
// Customizable Area End
